export default __webpack_public_path__ + "static/media/subircedula.23ce2d83.svg";